export const GET_FINAL_ACCOUNT_STATEMENT = 'GET_FINAL_ACCOUNT_STATEMENT';
export const GET_FINAL_ACCOUNT_STATEMENT_SUCCESS =
  'GET_FINAL_ACCOUNT_STATEMENT_SUCCESS';
export const GET_FINAL_ACCOUNT_STATEMENT_FAILURE =
  'GET_FINAL_ACCOUNT_STATEMENT_FAILURE';

export const GENERATE_FINAL_ACCOUNT_STATEMENT =
  'GENERATE_FINAL_ACCOUNT_STATEMENT';
